module.exports = __webpack_public_path__ + "static/006-3b546715ad7c542e3f7638f34d1380a0.jpg";